export const headerStyle = {
  background: 'linear-gradient(to right, #000040, #3b00ff)',
  padding: '10px',
  color: 'white',
}
